import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TFMService } from 'app/mock-api/tfm.service';
import { SlickCarouselModule } from 'ngx-slick-carousel';


@Component({
    selector: 'app-deals-type02',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [CommonModule, MatIconModule, SlickCarouselModule, MatIconModule],
    templateUrl: './deals-type02.component.html',
    styleUrl: './deals-type02.component.scss',
})
export class DealsType02Component implements OnInit {
    public view: any = {};

    constructor(private _tfmService: TFMService) {
        this._tfmService
            .filterBundles({ rateType: 'pps', onlyActive: true }, false)
            .then((res) => {
                this.view.bundles = res;

                let deals;

                // Check for Array
                if (Array.isArray(this.view.bundles.content)) {
                    deals = this.view.bundles.content;
                }

                //Convert to Array
                else {
                    deals = Object.values(this.view.bundles.content);
                }
                // this._tfmService.log('Deals: ', deals)

                //randomize Deals
                // deals.sort(() => Math.random() - 0.5);

                // Get first 4 deals
                this.view.deals = deals.slice(0, 6);
                this._tfmService.log(this.view.deals);
            });
    }

    ngOnInit(): void {
        this._tfmService.getSite().then((res) => {
            this.view.site = res;

            this.view.site.profile = this._tfmService.getSiteProfile(
                this.view.site.profileID
            );
            this._tfmService.log(this.view);
        });
    }
    slideConfig = {
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    // addSlide() {
    //   this.slides.push({img: "http://placehold.it/350x150/777777"})
    // }

    // removeSlide() {
    //   this.slides.length = this.slides.length - 1;
    // }

    slickInit(e) {
        this._tfmService.log('slick initialized');
    }

    breakpoint(e) {
        this._tfmService.log('breakpoint');
    }

    afterChange(e) {
    }

    beforeChange(e) {
    }
    slugify(text: string): string {
        return text
            .toLowerCase()
            .trim()
            .replace(/[\s\W-|]+/g, '-'); // Replace spaces and non-word characters with a hyphen
    }
}
